import React from "react";
import PropTypes from "prop-types";

import * as Theme from "../../../App/Theme";

import { shouldComponentUpdateGB } from "../../GB/NonComponents/GBUtil";

import GBStdChart from "../../../Library/Charts/GBStdChart";

import * as DMConst from "../NonComponents/DMConst";
import { getYearIdx } from "../NonComponents/DMUtil";

class DMAPA1Chart extends React.Component {
    static propTypes = {
        finalYear: PropTypes.number,
        left: PropTypes.number || PropTypes.string,
        navComboBoxHeight: PropTypes.number,
        results: PropTypes.object,
        right: PropTypes.number || PropTypes.string,
        selectedSNU_CurrID: PropTypes.number,
    };

    static defaultProps = {
        finalYear: DMConst.lastYearProgData,
        left: 0,
        navComboBoxHeight: 35,
        results: {},
        right: 0,
        selectedSNU_CurrID: 1,
    };

    /* Avoid re-rendering if we don't have to (if no props or state affect this form). */
    shouldComponentUpdate(nextProps, nextState) {
        return shouldComponentUpdateGB(this.props, nextProps, this.state, nextState);
    }

    //==================================================================================================================
    //
    //                                                 Render
    //
    //==================================================================================================================

    render() {
        try {
            const props = this.props;
            const results = props.results;
            const res = results[DMConst.rResult11];
            const inputs = results[DMConst.rInputs];
            const selectedSNU_CurrID = props.selectedSNU_CurrID;
            const navComboBoxHeight = props.navComboBoxHeight;
            const finalYear = props.finalYear;
            const left = props.left;
            const right = props.right;

            const pointLabels = res[DMConst.rPointLabels];
            const subsetLabels = res[DMConst.rSubsetLabels];
            const data1 = res[DMConst.rData1];
            const SNU_Data = data1[selectedSNU_CurrID];
            const yAxisLabel = res[DMConst.rYAxisLabel];

            const t1 = inputs[DMConst.rFirstYearMCIdx];
            const t2 = getYearIdx(finalYear);

            /* xAxis point labels */
            let categories = [];
            for (let a = DMConst.DP_A10_14; a <= DMConst.DP_A30_34; a++) {
                categories.push(pointLabels[a]);
            }

            /* Series names */
            let series = [];

            for (let t = t1; t <= t2; t++) {
                let data = [];
                for (let a = DMConst.DP_A10_14; a <= DMConst.DP_A30_34; a++) {
                    data.push(SNU_Data[a][t]);
                }

                series.push({
                    name: subsetLabels[t],
                    data: data,
                });
            }

            const chartOptions = {
                chart: {
                    type: "column",
                },

                title: {
                    text: res.title,
                    x: -20,
                },

                xAxis: {
                    categories: categories,
                    labels: {
                        step: 1,
                        rotation: 90,
                    },
                },

                yAxis: {
                    title: {
                        text: yAxisLabel,
                    },
                    tickAmount: 10,
                    plotLines: [
                        {
                            value: 0,
                            width: 1,
                            color: "#808080",
                        },
                    ],
                    reversedStacks: false,
                    labels: {
                        format: "{value:,.0f}",
                    },
                },

                plotOptions: {
                    series: {
                        animation: false,
                    },
                },

                credits: {
                    text: "",
                },

                legend: {
                    layout: "horizontal",
                    borderWidth: 0,
                },

                roundForDownloadCSV: true,

                colors: Theme.DM_ChartColors,

                series: series,
            };

            const chart = (
                <GBStdChart
                    chartType={"column"}
                    id={DMConst.rResult11}
                    key={Date.now() + 1}
                    options={chartOptions}
                    style={{
                        bottom: Theme.configDivStyle.height,
                        left: left,
                        overflow: "hidden",
                        position: "absolute",
                        right: right,
                        top: navComboBoxHeight,
                    }}
                />
            );

            return <div>{chart}</div>;
        } catch (exception) {
            return (
                <div
                    className={"DMAPA1ChartDiv"}
                    key={"DMAPA1ChartDiv"}
                >
                    <h3 key={"DMAPA1ChartDivH3"}>{exception.name + ": " + exception.message}</h3>
                </div>
            );
        }
    }
}

export default DMAPA1Chart;
